import {createContext} from 'react';

export interface PopoutWindowContextValue {
  popoutWindow: Window;
  popoutDocument: Document;
  isInPopout: boolean;
  popoutId: string | null;
}

export const defaultPopoutWindowContextValue: PopoutWindowContextValue = {
  popoutWindow:
    typeof window !== 'undefined' ? window : (null as unknown as Window),
  popoutDocument:
    typeof document !== 'undefined' ? document : (null as unknown as Document),
  isInPopout: false,
  popoutId: null,
};

// ----------------------------
// PopoutWindowContext
// ----------------------------
export const PopoutWindowContext = createContext<PopoutWindowContextValue>(
  defaultPopoutWindowContextValue
);
